<div class="header" [ngStyle]="{ 'background-image': bgImage}">
    <a href="https://www.futurearts.co/augmentseattle/" target="_blank" rel= noopener noreferrer nofollow class="header-logo">
        <img [src]="settings.header_image" [alt]="settings.header_image" *ngIf="settings.header_image">
    </a>
</div>